import { Injectable, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';

import { AuthService } from './auth.service';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class SessionRefreshService implements OnDestroy {
  private static readonly REFRESH_THRESHOLD_MS = 120_000;
  private static readonly CHECK_INTERVAL_MS = 500;

  private watchSub: Subscription | null = null;
  private isRefreshing = false;
  private started = false;

  constructor(
    private readonly auth: AuthService,
    private readonly tokens: TokenStorageService
  ) {}

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    this.watchSub = interval(SessionRefreshService.CHECK_INTERVAL_MS).subscribe(() => {
      this.refreshIfNeeded();
    });
    this.refreshIfNeeded();
  }

  ngOnDestroy(): void {
    this.watchSub?.unsubscribe();
  }

  private refreshIfNeeded(): void {
    if (this.isRefreshing || !this.tokens.refreshToken || this.tokens.isRefreshExpired) {
      return;
    }

    const accessExpiryTime = this.tokens.accessExpiryTime;
    if (!accessExpiryTime) {
      return;
    }

    const remainingMs = accessExpiryTime - Date.now();
    if (remainingMs > SessionRefreshService.REFRESH_THRESHOLD_MS) {
      return;
    }

    this.isRefreshing = true;
    this.auth.refresh().subscribe({
      next: () => {
        this.isRefreshing = false;
      },
      error: () => {
        this.isRefreshing = false;
      }
    });
  }
}
